
import Routing from "./Routes/Routes";
import { ChakraProvider } from '@chakra-ui/react'

function App() {
  return (
    <ChakraProvider className="App">
      <Routing />
    </ChakraProvider>
  );
}

export default App;
